import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
// import * as Sentry from '@sentry/browser'
// import { Vue as VueIntegration } from '@sentry/integrations'
import router from '@/router'
import store from '@/store/store'

import '@/socket'
import '@/filters'
import '@/plugins/axios'
import '@/plugins/sweetalert2'
import '@/plugins/vuePlyr'
import 'animate.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faSpinner, faAlignLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Sentry.init({
//   dsn: 'https://54e5843dbad74e18b2e898198741d633@o435808.ingest.sentry.io/5395777',
//   integrations: [new VueIntegration({ Vue, attachProps: true })],
// })

library.add(faUserSecret, faSpinner, faAlignLeft)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  document.title = 'EAD Viamaker | ' + to.meta.title
  next()
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
